<template>
    <div class="range-slider">
        <span
            :style="{width: progressWidth}"
            class="progress"
        />
        <input
            v-model="value"
            type="range"
            :min="options[index].min"
            :max="options[index].max"
            step="1"
            @input="updateValue($event.target)"
        >
        <div class="range-controls">
            <span
                v-for="(number) in rangeLength"
                :key="`option-${number-1}`"
            >
                {{ number - 1 }}
            </span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        layout: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        inputKey: {
            type: String,
            default: 'other',
        },
        index: {
            type: Number,
            default: 0,
        },
    },

    /**
     * @returns {object} Data object.
     */
    data() {
        return {
            value: 0,
            progress: 0,
        };
    },

    computed: {
        /**
         * Return range control length
         *
         * @returns {string} Range control length
         */
        rangeLength() {
            return +this.options[this.index].max + 1;
        },

        /**
         * Returns range progress
         *
         * @returns {string} range progress
         */
        progressWidth() {
            return `${this.progress}%`;
        },
    },

    /**
     * Created hook
     */
    created() {
        this.$emit('input', 0);
    },

    methods: {
        /**
         * Emits 'input' event
         *
         * @param {object} target Range input
         */
        updateValue(target) {
            this.setProgress(target);
            this.$emit('input', this.value);
        },

        /**
         * Set input progress change
         *
         * @param {object} target Range input
         */
        setProgress(target) {
            this.progress = ((target.valueAsNumber / this.options[this.index].max) * 100);
        },
    },
};
</script>
